import React from 'react';
import { Form } from 'react-form';
import { email } from '../../../utils/form-validation';

import Input from '../../Form/Input';

const SubscribeToMailList = props => {
    const { placeHolder, id, field, label, buttonLabel, handleSubmit, submitting, buttonStyle, hiddenLabel } = props;

    return (
        <div>
            <Form onSubmit={values => handleSubmit(values)}>
                {formApi => {
                    return (
                        <form onSubmit={formApi.submitForm} id="subscribeEmailForm">
                            <div className="row">
                                <div className="d-flex col-md-12">
                                    <Input
                                        label={label}
                                        id={id}
                                        field={field}
                                        placeholder={placeHolder}
                                        validate={email}
                                        formGroupCssClass={'form-group form-group-l w-100'}
                                        inputStyle={{ height: '32px' }}
                                        inputWrapperStyle={'d-flex'}
                                        hiddenLabel={hiddenLabel}
                                    >
                                        <button
                                            type="submit"
                                            disabled={submitting}
                                            className={buttonStyle}
                                        >
                                            {buttonLabel}
                                        </button>
                                    </Input>

                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    );
};

export default SubscribeToMailList;
